module.exports = __webpack_public_path__ + "img/card.2541aa53.jpg";